// LIBRARY
import React from "react";
import PropTypes from 'prop-types';
import { Form, Select } from 'antd';

// CUSTOM
import errorMessage from 'global_config/error_messages';
import { fetchCityList } from 'services/blood_bank/donor_registration';

const { Option } = Select;

class CityList extends React.Component { 

	constructor(props){
		super(props);

		this.state = {
			cityList: [],
			loading: false,
		};
	}
	
	componentDidMount() {
		this.fetchAndUpdateValues();
	}

	componentDidUpdate(prevProps) {
		const { provinceValue } = this.props;

		if(prevProps.provinceValue !== provinceValue){

			this.fetchAndUpdateValues();
		}
	}

	fetchAndUpdateValues = () => {
		const { provinceValue } = this.props;

		this.setState({ loading: true }, () => {
			const timer = setTimeout(async () => {
				const cityListResponse = provinceValue ? await fetchCityList(provinceValue) : [];

				this.setState({
					 loading: false, 
					 cityList: cityListResponse 
				});

				clearTimeout(timer);
			}, 300);
		});
	}

	orderListByKey = (data, key, order) => {
		const compareValues = (key, order = "asc") => (elemA, elemB) => {
			if (!elemA.hasOwnProperty(key) || !elemB.hasOwnProperty(key)) return 0;
			const comparison = elemA[key].localeCompare(elemB[key]);
			return order === "desc" ? comparison * -1 : comparison;
		};
		return data.sort(compareValues(key, order));
		}

	render(){
		const { placeholder, onChange, disabled } = this.props;
		const { cityList, loading } = this.state;
		const isDisabled = disabled || cityList.length < 1;

		return (
			<Form.Item 
				name="city" 
				label="CITY" 
				rules={[{ 
					required: true,//!isDisabled, 
					message: errorMessage.required
				}]}
			>
				<Select
					loading={loading}
					placeholder={placeholder}
					allowClear
					disabled={isDisabled}
					onChange={onChange}
					optionFilterProp="children"
					filterOption={(input, option) =>
						option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
					}
				>
					{this.orderListByKey(cityList, "city_name").map((item) => (
						<Option value={item.city_id} key={item.city_code}>
							{item.city_name}
						</Option> 
					))}
				</Select>
			</Form.Item>
		);
	}
}

CityList.propTypes = {
	placeholder: PropTypes.string.isRequired,
	provinceValue: PropTypes.number,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};

CityList.defaultProps = {
	provinceValue: null,
	disabled: false,
}

export default CityList;
  